import type {StyleFunctionProps} from '@chakra-ui/styled-system';
import {defineCssVars, defineStyleConfig} from '@chakra-ui/styled-system';
import {mode} from '@chakra-ui/theme-tools';

import {semantic as dark} from '../../../design-tokens/dark';
import {semantic} from '../../../design-tokens/light';

export const {backgroundColor: $backgroundColor} = defineCssVars(`tr`, [`backgroundColor`]);

export const tdCssVars = (props: StyleFunctionProps) => ({
  [$backgroundColor.variable]: `colors.${mode(
    semantic.colors.background.primary,
    dark.colors.background.primary,
  )(props)}`,
});

export const trStyle = defineStyleConfig({
  baseStyle: props => ({
    ...tdCssVars(props),
    // Typography
    bg: $backgroundColor.reference,
    // Hide actions trigger when the row is not hovered
    [`&[data-hover] [role="menubar"]`]: {
      visibility: `visible`,
    },
    [`&:hover [role="menubar"]`]: {
      visibility: `visible`,
    },
    [`& [role="menubar"][data-active]`]: {
      visibility: `visible`,
    },
    [`& [role="menubar"]`]: {
      visibility: `hidden`,
    },
    [`& [role="menu"]`]: {
      visibility: `hidden`,
    },
    [`&:hover [role="menu"]`]: {
      visibility: `visible`,
    },
    // Show actions trigger when the row is hovered (whether in the row actions or in one of the cells)
    [`[aria-controls="item-actions"]`]: {
      visibility: `hidden`,
      opacity: 0,
      transition: `opacity 0.2s ease-in-out`,
    },
    [`&:hover [aria-controls="item-actions"]`]: {
      visibility: `visible`,
      opacity: 1,
      transition: `opacity 0.2s ease-in-out`,
    },

    [`&[aria-selected="false"] [role="checkbox"]`]: {
      visibility: `hidden`,
    },
    [`&[aria-selected="false"]:hover [role="checkbox"]`]: {
      visibility: `visible`,
    },
  }),
});
